import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const useStyles = makeStyles((theme) => ({
  primaryRoot: {
    borderBottom: '1px solid',
    borderBottomColor: theme.palette.primary.main,
  },
  list: {
    listStyle: 'none',
    display: 'flex',
    alignItems: 'center',
    margin: 0,
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(1.5),
    padding: 0,
    [theme.breakpoints.down('md')]: {
      '& h6': {
        fontSize: 14,
      },
    },
  },
  arrow: {
    'marginLeft': theme.spacing(2),
    'marginRight': theme.spacing(2),
    'color': theme.palette.primary.main,
    '& svg': {
      fontSize: 12,
    },
    [theme.breakpoints.down('md')]: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
  },
  active: {
    opacity: 1,
  },
  inactive: {
    opacity: 0.3,
  },
  activeLink: {
    cursor: 'pointer',
    opacity: 1,
  },
  bold: {
    fontWeight: 700,
  },
}));

const PRIMARY = [
  {
    label: 'Program',
    step: 0,
  },
  {
    label: 'Graduation Year',
    step: 1,
  },
  {
    label: 'Payment',
    step: 3,
  },
  {
    label: 'Confirmation',
    step: 4,
  },
];

const SECONDARY = [
  { step: 0, label: 'Contract Overview', },
  { step: 1, label: 'Parent/Guardian Details', },
  { step: 2, label: 'Student Details', },
  { step: 3, label: 'Checkout', },
];

const PrimarySteps = ({ classes, currentStep, onChangeStep }) => (
  <Box className={classes.primaryRoot}>
    <ul className={classes.list}>
      {PRIMARY.map((i, x) => (
        <>
          <li
            className={
              i.step <= currentStep ? classes.activeLink : classes.inactive
            }
            onClick={() => {
              i.step < currentStep && onChangeStep(i.step);
            }}
          >
            <Typography variant="subtitle1">{i.label}</Typography>
          </li>
          {x < PRIMARY.length - 1 && (
            <li className={classes.arrow}>
              <ArrowForwardIosIcon />
            </li>
          )}
        </>
      ))}
    </ul>
  </Box>
);

const SecondarySteps = ({
  classes,
  currentStep,
  onChangeStep,
  skipParents,
}) => {
  const theme = useTheme();
  const STEPS = skipParents ? SECONDARY.filter((i, ) => i.step !== 1) : SECONDARY;

  return (
    <Box marginTop={theme.spacing(0.25)}>
      <ul className={classes.list}>
        {STEPS.map(
          (i, x) => (
            <>
              <li
                key={i.step}
                className={
                  i.step <= currentStep ? classes.activeLink : classes.inactive
                }
                onClick={() => {
                  i.step + 1 <= currentStep && onChangeStep(i.step);
                }}
              >
                <Typography className={classes.bold} variant="subtitle2">
                  {i.label}
                </Typography>
              </li>
              {x < STEPS.length - 1 && (
                <li className={classes.arrow}>
                  <ArrowForwardIosIcon />
                </li>
              )}
            </>
          ),
        )}
      </ul>
    </Box>
  );
};

const ProgressSteps = ({ currentStep, onChangeStep, skipParents }) => {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('md'));
  return (
    <Box marginBottom={{ xs: 4, md: 0 }}>
      <PrimarySteps
        classes={classes}
        currentStep={currentStep}
        onChangeStep={onChangeStep}
      />
      {matches && (
        <SecondarySteps
          skipParents={skipParents}
          currentStep={currentStep}
          classes={classes}
          onChangeStep={onChangeStep}
        />
      )}
    </Box>
  );
};

export default ProgressSteps;
